import React, { useState, useContext } from 'react'
import getCookie from '../../../partials/cookie';
import {Errors} from '../../../partials/Partials';
import { LoadingContext } from '../../../partials/Context';

function ChangeAccountBalance({services, lawyer_data, setCurrentBalance}) {
    
    const [current_value, setCurrentValue] = useState(''); 
    const [action, setAction] = useState(null)
    const [current_description,setCurrentDescription] = useState('')
    const [errors, setErrors] = useState([]);
    const {setLoading} = useContext(LoadingContext)

    let basic_service = {};
    const {balance, id} = lawyer_data || '';

    if (services) {
        services.forEach(service => {
            const {service_type} = service || ''
            if (service_type === 6) {
                basic_service = service;
            }
        })
    }

    const {price} = basic_service || '';

    const changeAccount = (e) => {
        setLoading(true)
        const csrftoken = getCookie('csrftoken')
        e.preventDefault()
        const description = e.target.querySelector('#description').value;
        const value = e.target.querySelector('#amount').value
        let value_converted = null;
        if (value) {
        if (action === '+') {
            value_converted = value
        } else if (action === '-') {
            value_converted = (-1)*value
        }
        fetch('/api/wallet_transactions/', {
            method:'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                value: value_converted,
                description: description,
                lawyer: id,
            })

        }).then(res => {
            if(res.ok) {
                setCurrentDescription('')
                setCurrentValue('')
                setCurrentBalance(oldValue => oldValue + value_converted)
                setErrors([])
                setLoading(false)
            } else {
                res.json().then(data=>{
                    const {description} = data || ''
                    if (description) {
                        setErrors(description)
                    }
                })
                setLoading(false)
            }
        })
        }
    }

    return (
    <div className="change-account-balance">
        <h3 className="title">Zmień saldo konta</h3>
        <form onSubmit={(e) => changeAccount(e)}>
            <div className="input-item col-sm-4">
                <label htmlFor="amount">Wpłata/wypłata</label>
                <input type="number" id="amount" step="0.01" min="0" value={current_value} onChange={(e)=>setCurrentValue(e.target.value)}/>
                złotych
            </div>
            <div className="input-item col-sm-10">
                <label htmlFor="description">Opis</label>
                <input type="text" id="description" value={current_description} onChange={(e)=>setCurrentDescription(e.target.value)}/>
            </div>
            <Errors small={true} errors={errors} />
            <div className="buttons">
                <button 
                    onClick={()=>setAction('+')} 
                    type="submit" 
                    className="btn btn-add" 
                    disabled={!current_value ? true : false}
                >Dodaj</button>
                <button 
                    onClick={()=>setAction('-')} 
                    type="submit" 
                    className="btn btn-subtract"  
                    disabled={!current_value ? true : false}
                    >Odejmij</button>
                <button 
                    onClick={(e) =>{e.preventDefault(); setCurrentValue(price/100)}} 
                    className="btn btn-subscription"
                >Ustaw kwotę abonamentu &nbsp;({price/100})</button>
                <button 
                    className="btn btn-amount"  
                    onClick={(e) =>{e.preventDefault(); setCurrentValue(balance)}}
                >Ustaw aktualne saldo prawnika  &nbsp;({balance})</button>
            </div>
        </form>
    </div>
  )
}

export default ChangeAccountBalance